


















import Vue from 'vue';
import Component from 'vue-class-component';
import { mdiAlertCircle } from '@mdi/js';

@Component
export default class Warning extends Vue {
	iconWarning = mdiAlertCircle;
}
